import { create } from 'zustand';

export interface IFormData {
  uniqueLink?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  countryCode?: string;
  roleId?: string;
  heardFrom?: string;
  otherSource?: string;
  referralCode?: string;
}

interface IAuthState {
  data: IFormData;
  setData: (newData: Partial<IFormData>) => void;
  reset: () => void;
}

export const useAuthStore = create<IAuthState>((set) => ({
  data: {},
  setData: (newData) => set((s) => ({ data: { ...s.data, ...newData } })),
  reset: () => set({ data: {} }),
}));
